export default function getJsonSafe<T>(input: string, defaultValue = {}): T {
  try {
    return JSON.parse(input)
  } catch {
    return defaultValue as T
  }
}
